import React, { Component } from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Autosuggest from "react-autosuggest";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import FilterWrapper from "../filter/FilterWrapper";
import Collapse from "@material-ui/core/Collapse";
import axios from "../../AxiosClient";
import moment from "moment";
import Icon from "@mdi/react";
import { mdiFilterVariant } from "@mdi/js";
import { withTranslation } from "react-i18next";
import Autocomplete from "@material-ui/lab/Autocomplete";

const styles = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  suggestionsContainerOpen: {
    marginTop: theme.spacing(1),
    left: 50,
    right: 0,
    zIndex: 99999999999999999999,
    boxShadow:
      "0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12)",
  },
  suggestion: {
    display: "block",
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },
  documentDialog: {
    minHeight: 400,
    minWidth: 400,
    overflow: "visible",
  },
});

const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};

export class DocumentAutosuggest extends Component {
  state = {
    documentSuggestions: [],
    documentAutocompleteLoading: false,
    documentSuggestInput: "",
    instance: new Date().getTime().toString(),
    filtersOpen: false,
    filters: {},
    defaultFilter: {
      liveDraft: "Live",
      languages: ["english"],
    },
    filterActive: false,
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {/* <Autosuggest
          // suggestions={this.state.documentSuggestions}
          // onSuggestionsFetchRequested={this.onDocumentSuggestionsFetchRequested}
          // onSuggestionsClearRequested={this.onDocumentSuggestionsClearRequested}
          // getSuggestionValue={this.getDocumentSuggestionValue}
          // onSuggestionSelected={this.onSuggestionSelected}
          // renderSuggestion={this.renderDocumentSuggestion}
          // theme={{
          //   container: classes.container,
          //   suggestionsContainerOpen: classes.suggestionsContainerOpen,
          //   suggestionsList: classes.suggestionsList,
          //   suggestion: classes.suggestion,
          // }}
          // inputProps={{
          //   // placeholder: this.props.t("document_autosuggest_choose"),
          //   // value: this.state.documentSuggestInput,
          //   // onChange: this.handleDocumentSuggestChange,
          //   // disabled: this.props.disabled,
          // }}
          // renderSuggestionsContainer={(options) => (
          //   <Paper
          //     {...options.containerProps}
          //     square
          //     style={{
          //       width: "75%",
          //       marginLeft: 10,
          //       marginBottom: 10,
          //       maxHeight: 350,
          //       overflow: "auto",
          //       position: "absolute",
          //     }}
          //   >
          //     {options.children}
          //   </Paper>
          // )}
          // renderInputComponent={(inputProps) => {
          //   const { classes, inputRef = () => {}, ref, ...other } = inputProps;

          //   return (
          //     <div>
          //       <TextField
          //         fullWidth
          //         aria-label="Search document input"
          //         InputProps={{
          //           inputRef: (node) => {
          //             ref(node);
          //             inputRef(node);
          //           },
          //           endAdornment: (
          //             <InputAdornment position="end">
          //               <IconButton
          //                 color={
          //                   this.state.filterActive === true
          //                     ? "secondary"
          //                     : "default"
          //                 }
          //                 onClick={this.openFilters}
          //               >
          //                 <Icon path={mdiFilterVariant} size={1} />
          //               </IconButton>
          //             </InputAdornment>
          //           ),
          //         }}
          //         {...other}
          //       />
          //       {this.state.documentAutocompleteLoading && (
          //         <LinearProgress color="secondary" />
          //       )}
          //     </div>
          //   );
          // }}
        /> */}

        <Autocomplete
          handleHomeEndKeys
          fullWidth
          openOnFocus
          disabled={this.props.disabled}
          options={this.state.documentSuggestions}
          onChange={this.onSuggestionSelected}
          getOptionSelected={(op, val) => {
            return op.title === val.title;
          }}
          disablePortal
          renderOption={this.renderDocumentSuggestion}
          inputValue={this.state.documentSuggestInput}
          onInputChange={this.handleDocumentSuggestChange}
          getOptionLabel={(option) => option.title}
          renderInput={(inputProps) => {
            const { classes, inputRef = () => {}, ref, ...other } = inputProps;
            return (
              <div>
                <TextField
                  fullWidth
                  aria-label="Search document input"
                  InputProps={{
                    inputRef: (node) => {
                      ref(node);
                      inputRef(node);
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          color={
                            this.state.filterActive === true
                              ? "secondary"
                              : "default"
                          }
                          onClick={this.openFilters}
                        >
                          <Icon path={mdiFilterVariant} size={1} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  {...other}
                />
                {this.state.documentAutocompleteLoading && (
                  <LinearProgress color="secondary" />
                )}
              </div>
            );
          }}
        />

        <Collapse in={this.props.filtersOpen}>
          {/* <SearchFilters handleDateChange={this.handleDateChange} filter={this.state.searchFilters} /> */}
          <FilterWrapper
            asPopper={false}
            open={false}
            onClose={() => {}}
            anchorEl={this.props.anchorEl}
            filterElement={"SearchFilters"}
            filter={this.state.filters}
            onFilterChange={this.onFilterChange}
            isFilterBar={false}
            title={""}
            showReset={
              Object.keys(this.state.filters).length > 0 ? true : false
            }
            resetToDefaultFilters={this.resetToDefaultFilters}
            filterInstance={this.state.filterInstance}
            defaultFilter={this.state.defaultFilter}
          />
        </Collapse>
      </div>
    );
  }

  openFilters = () => {
    this.setState({ filtersOpen: !this.state.filtersOpen });
  };

  onSuggestionSelected = (e, suggestion, suggestionValue, value) => {
    if (this.props.clearOnSelect) {
      this.setState({ documentSuggestInput: "" });
    } else {
      this.setState({ documentSuggestInput: suggestion.title });
    }
    this.onItemSelected(suggestion);
  };

  getDocumentSuggestionValue = (suggestion) => {
    return suggestion.title;
  };

  handleDocumentSuggestChange = (_e, newValue) => {
    if (_e && _e.type === "change") {
      this.setState({ documentSuggestInput: newValue });
      this.onDocumentSuggestionsFetchRequested(newValue);
    }
  };

  onFilterChange = (filters) => {
    let newFilters = {};
    let canReset = false;

    for (let [key, value] of Object.entries(filters)) {
      let type = typeof filters[key];
      if (typeof filters[key] === "object") {
        if (moment.isMoment(value) || moment.isDate(value)) {
          newFilters[key] = value;
          canReset = true;
        } else if (value.length > 0) {
          if (key === "taxonomy") {
            if (
              value.filter(
                (ele) => ele.type === "taxonomy" && ele.parentList.length === 0
              ).length === 0
            ) {
              newFilters[key] = value;
              canReset = true;
            }
          } else if (key === "documentTypes") {
            //-3 is all document types (i.e. no filter) if it's present don't add to the filter
            if (value.indexOf(-3) === -1) {
              newFilters[key] = value;
              canReset = true;
            }
          } else {
            if (!this.isDefaultFilter(key, value)) {
              newFilters[key] = value;
              canReset = true;
            }
          }
        }
      } else {
        if (!this.isDefaultFilter(key, value)) {
          newFilters[key] = value;
          canReset = true;
        }
      }
      //   else if ((moment.isMoment(value) || (moment.isDate(value)) )) {
      //   newFilters[key] = value
      //   // canReset = true
      // } else if ((typeof filters[key] === "string") && (value.trim().length > 0)) {
      //   if (!this.isDefaultFilter(key,value)){newFilters[key] = value}
      // } else if (typeof filters[key] === "number") {
      //   newFilters[key] = value
      //   // canReset = true
      // }
    }
    // (newFilters.hasOwnProperty("anyWordExact") ||
    //   newFilters.hasOwnProperty("allWordExact") ||
    //   newFilters.hasOwnProperty("exactPhrase") ||
    //   newFilters.hasOwnProperty("noWordExact") ||
    //   this.props.searchInProgress === true) &&
    //   this.props.activateSearch();

    this.setState({ filters: newFilters, filterActive: canReset });
  };
  isDefaultFilter = (key, value) => {
    return this.state.defaultFilter.hasOwnProperty(key) &&
      areObjectsEqual(value, this.state.defaultFilter[key])
      ? true
      : false;
  };

  resetToDefaultFilters = () => {
    this.setState({ filters: this.state.defaultFilter, filterActive: false });
  };

  onDocumentSuggestionsFetchRequested = (value) => {
    if (this.timeout) {
      // only need the latest request queued
      window.clearTimeout(this.timeout);
    }

    this.setState({ documentAutocompleteLoading: true });

    // queue the request so we don't machine gun them at the backend
    this.timeout = window.setTimeout(() => {
      axios
        .post("/search/", {
          ...this.state.filters,
          liveDraftMode: this.state.filters.liveDraft,
          searchString: value,
        })
        .then((res) => {
          this.setState({ documentSuggestions: res.data.page.content }, () =>
            this.setState({ documentAutocompleteLoading: false })
          );
        });
      // clear the queue
      this.timeout = null;
    }, 750);
  };

  renderDocumentSuggestion = (suggestion, query) => {
    return (
      <MenuItem
        selected={query.selected}
        component="div"
        onClick={() => this.onItemSelected(suggestion)}
      >
        <Typography noWrap>{suggestion.title}</Typography>
      </MenuItem>
    );
  };

  onItemSelected = (item) => {
    // this.setState({ documentSuggestInput: "" });
    this.props.onItemSelected(item);
  };

  onDocumentSuggestionsClearRequested = () => {
    this.setState({ documentSuggestions: [] });
  };
}

const mapStateToProps = (state) => ({
  filters: state.search.filters,
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withTranslation()(DocumentAutosuggest)));
